module.exports = __webpack_public_path__ + "media/images/icon-card/icon-card-09-f49f77c083059ba6ba0a8357e8946760.svg";